<template>
  <div id="body">
    <img id="logo" :src="require('@/assets/imgs/logo-black.png')" @click="toHome()" />
    <article class="container">
      <div>
        <h1>Welcome back</h1>
        <div id="content" class="container login-container">
          <label class="pure-material-textfield-outlined">
            <input
              class="form-control"
              type="email"
              v-model="email"
              @keyup="checkUserEmail"
              placeholder=" "
            />
            <span>Email</span>
            <p class="error-message">{{email_message || "&nbsp;"}}</p>
          </label>
          <label class="pure-material-textfield-outlined">
            <input
              class="form-control"
              type="password"
              @keyup="checkPasswordLength"
              v-model="password"
              placeholder=" "
            />
            <span>Password</span>
            <p class="error-message">{{password_message || "&nbsp;"}}</p>
          </label>
          <button @click="userLogin" class="btn color-btn" style="margin-top: 1rem;">Log in</button>
          <p style="text-align:center;margin-top:1rem;" class="error-message">
            {{login_error || "&nbsp;"}}
            <span
              v-if="login_error == '*Email is not verified' && show_resend_email_span"
              class="resend-btn"
              @click="resendEmail()"
            >Resend Verify Email</span>
          </p>
          <pulse-loader
            class="pulse-loader"
            v-if="loading"
            :loading="loading"
            :color="loading_color"
            :size="loading_size"
          ></pulse-loader>
          <p v-if="!loading">Or continue with</p>
          <div class="d-flex flex-row justify-content-center mb-1 social-icons">
            <img
              src="@/assets/imgs/google.png"
              class="social-icon"
              ref="google-auth"
              @click="googleOAuth"
              v-if="!loading"
            />
            <img
              src="@/assets/imgs/linkedin.png"
              class="social-icon"
              ref="linkedin-auth"
              @click="linkedinOAuth"
              v-if="!loading"
            />
          </div>

          <hr class="divider" />

          <p style="text-align:center; margin-top:1rem;">
            Forgot your password?
            <span @click="toResetPassword">Reset your password</span>
          </p>
        </div>
        <p style="margin-top:1rem">
          Don't have an account yet.
          <span @click="toSignUpPage">Sign up</span>
        </p>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState } from "vuex";
import globalConstants from "@/utils/global-constants.js";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import oauth from "@/utils/oauth";

export default {
  data() {
    return {
      email: "",
      password: "",
      email_message: "",
      password_message: "",
      login_error: "",

      // State Variables
      loading: false,
      logged: false,
      loading_color: "lightgreen",
      loading_size: "1rem",

      show_resend_email_span: true
    };
  },

  components: { PulseLoader },

  computed: {
    ...mapState({
      loggedIn: state => state.UserService.idToken !== null,
      formError: state => state.UserService.formError
    })
  },

  methods: {
    googleOAuth() {
      this.loading = true;
      const redirect_url = globalConstants.OAUTH_GOOGLE_REDIRECT_URL;
      let client_id =
        "339015305647-v5und7jql55810ujo7suqu49obrn24t1.apps.googleusercontent.com";
      let ggOAuth = new oauth(
        `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${client_id}&scope=openid%20profile%20email&redirect_uri=${redirect_url}&state=state&nonce=0394852-3190485-2490358&`,
        "Google",
        { width: 527, height: 582 }
      );

      ggOAuth.open(redirect_url).then(
        res => {
          console.log("Success Google Oauth", res);
          this.$store
            .dispatch("googleOAuthLogin", { ...res, redirect_url })
            .then(
              resp => {
                console.log("[GoogleOAuthLogin] Success", resp);
                this.setWindowLocalStorage("email", resp.data.email);
                this.setWindowLocalStorage("token", resp.data.token);
                this.setWindowLocalStorage("role", resp.data.role);
                this.setWindowLocalStorage(
                  "expirationDate",
                  new Date(Date.now() + 1000 * 3600 * 24 * 30) // 30 days
                );
                this.$store.commit("setUserEmail", resp.data.email);

                this.$store.commit("authUser", resp.data);
                this.loading = false;
                $("#GetFreeApiModal").modal("hide");
                mixpanel.register({
                  email: resp.data.email,
                  method: "oauth_google"
                });
                // this.$router.replace("/insight/news");
                this.$router.replace("/solution");
              },
              error => {
                console.log("[GoogleOAuthLogin] Fail", error);
                if (error.message == "Network Error") {
                  this.login_error = "*oops... please try again later";
                  this.signup_error = "*oops... please try again later";
                } else {
                  this.login_error = error.response.data.message;
                  this.signup_error = error.response.data.message;
                }
                this.loading = false;
              }
            );
        },
        err => {
          console.log("Failed Google Oauth", err);
          this.$store.dispatch("notify", {
            info: err,
            type: "error"
          });
          this.loading = false;
        }
      );
    },

    linkedinOAuth() {
      this.loading = true;
      const redirect_url = globalConstants.OAUTH_LINKEDIN_REDIRECT_URL;
      let lnOAuth = new oauth(
        "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86f1r0asmt8600&redirect_uri=" +
          redirect_url +
          "&scope=r_liteprofile%20r_emailaddress%20w_member_social",
        "Linkedin",
        { width: 527, height: 582 }
      );

      lnOAuth.open(redirect_url).then(
        res => {
          console.log("Success linkedin Oauth", res);
          this.$store
            .dispatch("linkedinOAuthLogin", { ...res, redirect_url })
            .then(
              resp => {
                console.log("[linkedinOAuthLogin] Success", resp);
                this.setWindowLocalStorage("email", resp.data.email);
                this.setWindowLocalStorage("token", resp.data.token);
                this.setWindowLocalStorage("role", resp.data.role);
                this.setWindowLocalStorage(
                  "expirationDate",
                  new Date(Date.now() + 1000 * 3600 * 24 * 30) // 30 days
                );
                this.$store.commit("setUserEmail", resp.data.email);

                this.$store.commit("authUser", resp.data);
                this.loading = false;
                $("#GetFreeApiModal").modal("hide");
                mixpanel.register({
                  email: resp.data.email,
                  method: "oauth_linkedin"
                });
                // this.$router.replace("/insight/news");
                this.$router.replace("/solution");
              },
              error => {
                console.log("[linkedinOAuthLogin] Fail", error);
                if (error.message == "Network Error") {
                  this.login_error = "*oops... please try again later";
                  this.signup_error = "*oops... please try again later";
                } else {
                  this.login_error = error.response.data.message;
                  this.signup_error = error.response.data.message;
                }
                this.loading = false;
              }
            );
        },
        err => {
          console.log("Failed linkedin Oauth", err);
          this.$store.dispatch("notify", {
            info: err,
            type: "error"
          });
          this.loading = false;
        }
      );
    },

    resendEmail() {
      console.log("resend email is: ", this.email);
      this.show_resend_email_span = false;

      fetch(this.$globalConstants.BASE_URL + "user/resendverifyemail", {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({
          email: this.email
        })
      })
        .then(data => {
          if (data.status !== 200) {
            console.log("Request failed: ", data);
            this.$store.dispatch("notify", {
              info: "Resend Failed. Please try again later.",
              type: "error"
            });
          } else {
            console.log("Request success: ", data);
            this.$store.dispatch("notify", {
              info: "Email sent successfully.",
              type: "success"
            });
          }
        })
        .catch(err => {
          console.log("Request failed: ", err);
          this.$store.dispatch("notify", {
            info: "Resend Failed. Please try again later.",
            type: "error"
          });
        });
    },

    toHome() {
      this.$router.push({ name: "home-page" });
    },

    toSignUpPage() {
      this.$router.push({ name: "signup-page" });
    },

    toResetPassword() {
      this.$router.push({ name: "reset-password" });
    },

    checkUserEmail() {
      if (!this.checkEmailFormat(this.email)) {
        this.email_message = "*Invalid email format";
      } else {
        this.email_message = "";
      }
    },

    checkPasswordLength() {
      // get the global constant
      const len = this.$globalConstants.MIN_PASSWORD_LENGTH || 10;
      if (this.password.length < len) {
        this.password_message = `*Password must be at least ${len} characters long`;
      } else {
        this.password_message = "";
      }
    },

    setUserDataInLocalStorage(res, formData) {
      this.setWindowLocalStorage("email", formData.email);
      this.setWindowLocalStorage("token", res.data.token);
      this.setWindowLocalStorage("role", res.data.role);
      this.setWindowLocalStorage("username", res.data.name);
      this.setWindowLocalStorage(
        "expirationDate",
        new Date(Date.now() + 1000 * 3600 * 24 * 30) // 30 days
      );
    },

    userLogin() {
      // validate sign in form
      this.checkUserEmail();
      this.checkPasswordLength();
      const { email_message, password_message } = this;
      this.$store.dispatch("validateForm", { email_message, password_message });
      if (!this.formError) {
        const { email, password } = this;
        this.submitSignInForm({ email, password });
      }
    },

    submitSignInForm(formData) {
      // console.log(formData);
      this.$store.commit("setLoadingStatus", true);
      this.$store
        .dispatch("login", formData)
        .then(res => {
          // save user auth data
          this.setUserDataInLocalStorage(res, formData);
          this.$store.commit("authUser", res.data);

          // get user profile data
          this.$store
            .dispatch("getProfile", { token: res.data.token })
            .then(response => response.json())
            .then(res => {
              console.log(
                "[signin-page] submitSignInForm() getProfile, res is: ",
                res
              );
              this.$store.commit("saveUserInfoInState", res);
              let plan = res.plan ? res.plan : "free";
              this.setWindowLocalStorage("userPlan", plan);
              this.setWindowLocalStorage("apikey", res.accessKey);
            })
            .catch(err => {
              console.log("submitSignInForm() getProfile ERROR: ", err);
            })
            .finally(() => {
              //if login successfully go to api documentation page
              // this.$router.replace("/insight/news");
              this.$router.replace("/solution");
            });
        })
        .catch(error => {
          console.log("[sigin-page] submitSignInForm() ERROR: ", error);
          this.$store.commit("setLoadingStatus", false);
          if (error.message == "Network Error") {
            this.login_error = "*oops... please try again later";
          } else if (
            error.response.data.message == "please verify your email first"
          ) {
            this.login_error = "*Email is not verified";
          } else if (error.response.data.message == "user doesn't exist!") {
            this.login_error = "*Please sign up first";
          } else {
            this.login_error = "*Invalid credentials";
          }
        })
        .finally(() => {
          this.$store.commit("setLoadingStatus", false);
        });
    }
  }
};
</script>

<style scoped>
* {
  font-family: Raleway;
  font-weight: bold;
}

#body {
  background: url("../../assets/imgs/purewhite_curveline.png") no-repeat center
    fixed;
  background-size: cover;
  min-height: 100vh;
}

.login-container {
  justify-content: space-between;
}

.color-btn {
  width: 100%;
  background: #f5a623;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.47px;
  color: #ffffff;
}

p {
  font-size: 1rem;
  text-align: center;
}

p span {
  color: #f5a623;
  text-decoration: underline;
}

p > span:hover {
  cursor: pointer;
}

#logo {
  width: 10rem;
  height: 2rem;
  margin-left: 3rem;
  margin-top: 1rem;
  cursor: pointer;
}

.social-icon {
  width: 48px;
  height: 48px;
  cursor: pointer;
  margin: 0 1rem 1rem;
}

.social-icons {
  margin-top: 1rem;
}

.pulse-loader {
  text-align: center;
}

.error-message {
  font-size: 1rem;
  color: red;
  margin-left: 2px;
  text-align: left;
}

hr.divider {
  height: 1px;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
/* css effects for input */

.pure-material-textfield-outlined {
  position: relative;
  display: block;
  padding-top: 6px;
  font-size: 16px;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input {
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  border-top-color: transparent;
  border-radius: 4px;
  width: 100%;
  height: inherit;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  width: 100%;
  max-height: 100%;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown */
.pure-material-textfield-outlined > input:not(:focus):placeholder-shown {
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
}

.pure-material-textfield-outlined > input:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 50px;
}

.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Focus */
.pure-material-textfield-outlined > input:focus {
  /* border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
  border-top-color: transparent;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input:focus + span {
  /* color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
}

.pure-material-textfield-outlined > input:focus + span::before,
.pure-material-textfield-outlined > input:focus + span::after {
  border-top-color: #16abbd !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* error */
.pure-material-textfield-outlined > input.error,
.pure-material-textfield-outlined > input.error + span {
  border-color: red !important;
  border-top-color: transparent !important;
}

.pure-material-textfield-outlined > input.error + span::before,
.pure-material-textfield-outlined > input.error + span::after {
  border-top-color: red !important;
}

.pure-material-textfield-outlined > input.error:placeholder-shown,
.pure-material-textfield-outlined > input.error:placeholder-shown + span {
  border-top-color: red !important;
}

.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::after {
  border-top-color: transparent !important;
}

/* Error && Focus */
.pure-material-textfield-outlined > input.error:focus {
  border-color: red;
  border-top-color: transparent !important;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input.error:focus + span::before,
.pure-material-textfield-outlined > input.error:focus + span::after {
  border-top-color: red !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

@media (min-width: 768px) {
  h1 {
    margin-top: 5rem;
    text-align: center;
    font-family: Jura;
    font-size: 48px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #4a4a4a;
  }

  #content {
    max-width: 30rem;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    margin: auto;
  }
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined
      > input
      + span
      .pure-material-textfield-outlined
      > input
      + span::before,
    .pure-material-textfield-outlined > input + span::after {
      transition-duration: 0.1s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/static/signin-page.vue